import React from "react";
import styled from "styled-components";
import {
  Card, Row, Col, Container
} from "reactstrap";
import HeaderTable from "views/GeneralRegister/modalComponents/HeaderTable";
import UsersTable from "./UsersTable";
import UserCreate from "./UserCreate";

const CardContainer = styled(Card)`
  width: 100%;
`;

class UserManagement extends React.Component {
  state = {
    modalOpen: false,
  }

  openModal = () => this.setState({ modalOpen: true })

  closeModal = () => this.setState({ modalOpen: false })

  render() {
    return (
      <div className="content">
        <Container fluid>
          <Row>
            <Col sm={12}>
              <CardContainer>
                <HeaderTable title="Usuários" buttonLabel="Cadastrar" onClick={this.openModal} />
                <UsersTable />
              </CardContainer>
            </Col>
          </Row>
          {this.state.modalOpen && (
            <UserCreate isOpen toggleModal={this.closeModal} />
          )}
        </Container>
      </div>
    );
  }
}

export default UserManagement;
